import { Icon, type IconProps } from '@chakra-ui/react';

/**
 * The SVG icon of the Duke logo.
 * @props The HTML Chakra props of the SVG element.
 */
export function IconLogo(props: IconProps) {
  return (
    <Icon width="32px" height="32px" viewBox="0 0 32 32" color="#8445BC" {...props}>
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16V32H16C7.16344 32 0 24.8366 0 16Z"
        fill="currentColor"
      />
      <mask
        id="mask0_1603_92629"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16V32H16C7.16344 32 0 24.8366 0 16Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1603_92629)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.1692 16.2169C25.1714 16.2991 25.1725 16.3815 25.1725 16.4642C25.1725 21.4447 21.2204 25.4933 15.9831 25.4933C10.7779 25.4933 6.82581 21.4447 6.82581 16.4642C6.82581 11.4516 10.7779 7.43503 15.9831 7.43503C17.7815 7.43503 19.4401 7.92048 20.8388 8.76447V0H25.1725V16.2155C25.1725 16.2155 25.1714 16.216 25.1692 16.2169ZM20.7706 16.4321C20.7706 19.1312 18.6499 21.284 16.0152 21.284C13.3484 21.284 11.2599 19.1312 11.2599 16.4321C11.2599 13.7329 13.3484 11.5801 16.0152 11.5801C18.6499 11.5801 20.7706 13.7329 20.7706 16.4321Z"
          fill="white"
        />
      </g>
    </Icon>
  );
}

export default IconLogo;
